import Chart from "react-apexcharts";
import { fmtBRL, fmtInt } from "@/lib/api";
import { apexBase, useChartTheme, PALETTE } from "@/components/production/pcShared";
import { Panel, Empty, GrowthCell, ShareBar } from "./biShared";

export default function BiStoresTab({ data }) {
  const dark = useChartTheme();
  const base = apexBase(dark);
  const stores = data.by_store || [];

  return (
    <div className="space-y-3" data-testid="bi-stores-tab">
      <Panel title="FATURAMENTO POR LOJA" testid="bi-chart-stores-bar">
        {stores.length === 0 ? <Empty /> : (
          <Chart type="bar" height={Math.max(180, stores.length * 44)}
            series={[
              { name: "Bruto", data: stores.map((s) => s.gross) },
              { name: "Líquido", data: stores.map((s) => s.net) },
            ]}
            options={{
              ...base,
              plotOptions: { bar: { horizontal: true, borderRadius: 3 } },
              xaxis: { categories: stores.map((s) => s.store), labels: { formatter: (v) => fmtBRL(v) } },
              tooltip: { ...base.tooltip, y: { formatter: (v) => fmtBRL(v) } },
              legend: { fontSize: "10px" },
              colors: [PALETTE[0], PALETTE[2]],
            }} />
        )}
      </Panel>

      <Panel title="RANKING DE LOJAS" testid="bi-table-stores">
        {stores.length === 0 ? <Empty /> : (
          <div className="overflow-x-auto">
            <table className="table table-compact">
              <thead>
                <tr>
                  <th>Loja</th><th>Canal</th><th className="text-right">Pedidos</th>
                  <th className="text-right">Unidades</th><th className="text-right">Copos</th>
                  <th className="text-right">Bruto</th><th className="text-right">Líquido</th>
                  <th className="text-right">Ticket</th><th>Share</th><th className="text-right">Cresc.</th>
                </tr>
              </thead>
              <tbody>
                {stores.map((s) => (
                  <tr key={s.store} data-testid={`bi-store-row-${s.store}`}>
                    <td className="font-bold">{s.store}</td>
                    <td className="text-zinc-500">{s.channel}</td>
                    <td className="text-right font-mono">{fmtInt(s.orders)}</td>
                    <td className="text-right font-mono">{fmtInt(s.units)}</td>
                    <td className="text-right font-mono">{fmtInt(s.cups)}</td>
                    <td className="text-right font-mono font-bold text-green-600">{fmtBRL(s.gross)}</td>
                    <td className="text-right font-mono">{fmtBRL(s.net)}</td>
                    <td className="text-right font-mono">{fmtBRL(s.ticket)}</td>
                    <td><ShareBar pct={s.share} /></td>
                    <td className="text-right"><GrowthCell pct={s.growth_pct} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
